import Tab from "components/Tab";
import WebInstall from "../../../../contents/docs/integrate/_snippets/install-web.mdx";
import ReactInstall from "../../../../contents/docs/integrate/_snippets/install-react.mdx";
import NodeInstall from "../../../../contents/docs/integrate/_snippets/install-node.mdx";
import PythonInstall from "../../../../contents/docs/integrate/_snippets/install-python.mdx";
import PHPInstall from "../../../../contents/docs/integrate/_snippets/install-php.mdx";
import RubyInstall from "../../../../contents/docs/integrate/_snippets/install-ruby.mdx";
import GoInstall from "../../../../contents/docs/integrate/_snippets/install-go.mdx";
import ReactNativeInstall from "../../../../contents/docs/integrate/_snippets/install-react-native.mdx";
import AndroidInstall from "../../../../contents/docs/integrate/_snippets/install-android.mdx";
import IOSInstall from "../../../../contents/docs/integrate/_snippets/install-ios.mdx";
import ElixirInstall from "../../../../contents/docs/integrate/_snippets/install-elixir.mdx";
import DotNetInstall from "../../../../contents/docs/integrate/_snippets/install-dotnet.mdx";
import Wizard from "../../../../contents/docs/getting-started/_snippets/wizard.mdx";
import * as React from 'react';
export default {
  Tab,
  WebInstall,
  ReactInstall,
  NodeInstall,
  PythonInstall,
  PHPInstall,
  RubyInstall,
  GoInstall,
  ReactNativeInstall,
  AndroidInstall,
  IOSInstall,
  ElixirInstall,
  DotNetInstall,
  Wizard,
  React
};